import { render, staticRenderFns } from "./AppTabSubscriptionOrder.vue?vue&type=template&id=bb271c14&scoped=true"
import script from "./AppTabSubscriptionOrder.vue?vue&type=script&lang=js"
export * from "./AppTabSubscriptionOrder.vue?vue&type=script&lang=js"
import style0 from "./AppTabSubscriptionOrder.vue?vue&type=style&index=0&id=bb271c14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb271c14",
  null
  
)

export default component.exports